import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoTypo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 190,
	height: 40,
	viewBox: "0 0 190 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 2,
			y: 7,
			width: 36,
			height: 31,
			rx: 4,
			fill: "#FB7185"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2 11C2 8.79086 3.79086 7 6 7H34C36.2091 7 38 8.79086 38 11V17H2V11Z",
			fill: "#F43F5E"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 11,
			y: 3,
			width: 5,
			height: 9,
			rx: 2.5,
			fill: "#FECDD3"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 24,
			y: 3,
			width: 5,
			height: 9,
			rx: 2.5,
			fill: "#FECDD3"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 24,
			r: 2.5,
			fill: "white",
			fillOpacity: .55
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 20,
			cy: 24,
			r: 2.5,
			fill: "white",
			fillOpacity: .55
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 28,
			cy: 24,
			r: 5.5,
			fill: "white",
			fillOpacity: .22
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 28,
			cy: 24,
			r: 3,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 33,
			r: 2.5,
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 20,
			cy: 33,
			r: 2.5,
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 28,
			cy: 33,
			r: 2.5,
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsxs("text", {
			x: 50,
			y: 22,
			fontFamily: "Inter, Arial, sans-serif",
			fontSize: 23,
			fontWeight: 700,
			letterSpacing: -.3,
			dominantBaseline: "central",
			children: [/* @__PURE__ */ _jsx("tspan", {
				fill: "#F1F2F4",
				children: "Coval"
			}), /* @__PURE__ */ _jsx("tspan", {
				fill: "#FB7185",
				children: " Flow"
			})]
		})
	]
});
export default SvgLogoTypo;
